/**
 * This file contains a collection of functions to convert all the content components to html
 */

import {
	Button,
	Heading,
	IconWithText,
	Image,
	ImageWithText,
	ImageWithText2,
	ImageWithText3,
	LinkList,
	List,
	PostContent,
	Table,
	Text,
	Video
} from '../models/post';

function headingToHTML(content: PostContent) {
	const heading = content.value as Heading;

	switch (heading.size) {
		case "1":
			return `<h2 class="magazin-article-subheading ${heading.alignment === "center" ? "text-align-center" : ""}">${heading.text}</h2>`;
		case "2":
			return `<h3 class="magazin-article-subheading ${heading.alignment === "center" ? "text-align-center" : ""}">${heading.text}</h3>`;
		case "3":
			return `<h4 class="magazin-article-subheading ${heading.alignment === "center" ? "text-align-center" : ""}">${heading.text}</h4>`;
	}
}

function formatText(text: string, pg?: boolean) {
	const l = '<p class="image-with-text-blog__text-left">';
	const p = '<p class="magazin-text-left bl-font magazin-size">';

	return text
		.replaceAll('<p>', pg ? p : l)
		.replaceAll('<ol>', '<ol class="magazin-ol magazin-size">')
		.replaceAll('<ul>', '<ul class="magazin-ul magazin-size">');
}

function textToHTML(content: PostContent) {
	const text = content.value as Text;
	return formatText(text.text, true);
}

function imageToHTML(content: PostContent) {
	const image = content.value as Image;
	const imageHTML = `<div class="magazin-text-left bild-center"><img src="${image.src}"  alt="${image.alt}" /></div>`;
	if (image.link === "") return imageHTML;
	return `<a href="${image.link}">${imageHTML}</a>`;
}

function listToHTML(content: PostContent) {
	const list = content.value as List;

	let html = '<ul class="magazin-ul magazin-size">'
	for (let item of list.items) {
		html += `<li>${item}</li>`;
	}
	html += "</ul>"

	return html;
}

function linkListToHTML(content: PostContent) {
	const list = content.value as LinkList;

	let html = '<ul class="magazin-ul magazin-size">'
	for (let item of list.items) {
		html += `<li><a href="${item.link}" target="_blank" rel="noopener noreferrer">${item.text}</a></li>`;
	}
	html += "</ul>"

	return html;
}

function iconWithTextToHTML(content: PostContent) {
	const iconWithText = content.value as IconWithText;
	return `<div class="icon-with-text bl-font magazin-size">
	<div class="icon-magazin"><img src="${iconWithText.icon}"  alt=""/></div>
	<div class="icon-text">${formatText(iconWithText.text)}</div></div>`;
}

function imageWithTextToHTML(content: PostContent) {
	const imageWithText = content.value as ImageWithText;

	let imageHTML = `<img src="${imageWithText.image.src}"  alt=${imageWithText.image.alt} />`;

	if (imageWithText.image.link !== "") imageHTML = `<a href="${imageWithText.image.link}">${imageHTML}</a>`;

	if (imageWithText.alignment === "left") {
		return `<div class="image-with-text-blog bl-font">
		<div class="image-magazin rounded rounded-margin">${imageHTML}</div>
		<div class="image-text magazin-size">
			${formatText(imageWithText.text)}
		</div>
		</div>
	`;
	}
	return `<div class="image-with-text-blog image-right bl-font">
	<div class="image-magazin image-padding rounded rounded-margin">${imageHTML}</div>
	<div class="image-text text-left magazin-size">
		${formatText(imageWithText.text)}
	</div>
	</div>
	`;
}

function imageWithText2ToHTML(content: PostContent) {
	const imageWithText2 = content.value as ImageWithText2;
	let image1HTML = `<img class="image-grid-half" src="${imageWithText2.image1.src}" alt=${imageWithText2.image1.alt} />`;
	let image2HTML = `<img class="image-grid-half" src="${imageWithText2.image2.src}" alt=${imageWithText2.image2.alt} />`;

	if (imageWithText2.image1.link !== "") image1HTML = `<a href="${imageWithText2.image1.link}">${image1HTML}</a>`;
	if (imageWithText2.image2.link !== "") image2HTML = `<a href="${imageWithText2.image2.link}">${image2HTML}</a>`;

	return `<div class="magazin-grid magazin-text-left bl-font magazin-size">
	<div class="magazin-grid-element-half">
	<div class="magazin-grid-image rounded">${image1HTML}</div>
	<div class="magazin-grid-text">
	${formatText(imageWithText2.text1)}
	</div>
	</div>
	<div class="magazin-grid-element-half">
	<div class="magazin-grid-image rounded">${image2HTML}</div>
	<div class="magazin-grid-text">
	${formatText(imageWithText2.text2)}
	</div>
	</div>
	</div>
	`;
}

function imageWithText3ToHTML(content: PostContent) {
	const imageWithText3 = content.value as ImageWithText3;
	let image1HTML = `<img class="image-grid-half" src="${imageWithText3.image1.src}" alt=${imageWithText3.image1.alt} />`;
	let image2HTML = `<img class="image-grid-half" src="${imageWithText3.image2.src}" alt=${imageWithText3.image2.alt} />`;
	let image3HTML = `<img class="image-grid-half" src="${imageWithText3.image3.src}" alt=${imageWithText3.image3.alt} />`;

	if (imageWithText3.image1.link !== "") image1HTML = `<a href="${imageWithText3.image1.link}">${image1HTML}</a>`;
	if (imageWithText3.image2.link !== "") image2HTML = `<a href="${imageWithText3.image2.link}">${image2HTML}</a>`;
	if (imageWithText3.image3.link !== "") image3HTML = `<a href="${imageWithText3.image3.link}">${image3HTML}</a>`;

	return `<div class="magazin-grid magazin-text-left bl-font magazin-size">
	<div class="magazin-grid-element">
	<div class="magazin-grid-image rounded">${image1HTML}</div>
	<div class="magazin-grid-text">
	${formatText(imageWithText3.text1)}
	</div>
	</div>
	<div class="magazin-grid-element ">
	<div class="magazin-grid-image rounded">${image2HTML}</div>
	<div class="magazin-grid-text">
	${formatText(imageWithText3.text2)}
	</div>
	</div>
	<div class="magazin-grid-element">
	<div class="magazin-grid-image rounded">${image3HTML}</div>
	<div class="magazin-grid-text">
	${formatText(imageWithText3.text3)}
	</div>
	</div>
	</div>
	`;
}

function buttonToHTML(content: PostContent) {
	const button = content.value as Button;
	return `<div class="magazin-button__wrapper"><a class="magazin-button" href="${button.link}">${button.label}</a></div>`
}

function videoToHTML(content: PostContent) {
	const video = content.value as Video
	return `<div class="video-frame" style="margin-bottom: 30px;"><iframe loading="lazy" src="${video.src}" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe></div>`;
}

function tableToHTML(content: PostContent) {
	const table = content.value as Table;
	let tableContent: string = "";
	if (table.columnCount === 1) {
		const rows = table.columns[0] as string[];
		tableContent = `<div class="spalte-mitte">${rows.map((r, i) => `<p class="zeile${i===0 ? '-oben' : ''}">${r}</p>`)}</div>`;
	} else {
		for (let i = 0; i < table.columns.length; i++) {
			let cssClass = "spalte-mitte";
			if (i === 0) {
				cssClass = "spalte-links";
			} else if (i === table.columns.length-1) {
				cssClass = "spalte-rechts";
			}
			const rows = table.columns[i] as string[];
			tableContent += `<div class="${cssClass}">${rows.map((r, i) => `<p class="zeile${i===0 ? '-oben' : ''}">${r}</p>`)}</div>`;
		}
	}
	return `<div class="tabelle bl-font magazin-size">${tableContent}</div>`;
}


// Receives the list of content as a parameter and then calls the corresponding functions based on the content type
export default function postContentToHTML(content: PostContent[]) {
	let html = "";

	for (let c of content) {
		switch (c.type) {
			case "heading":
				html += headingToHTML(c);
				break;
			case "text":
				html += textToHTML(c);
				break;
			case "image":
				html += imageToHTML(c);
				break;
			case "list":
				html += listToHTML(c);
				break;
			case "list_with_links":
				html += linkListToHTML(c);
				break;
			case "icon_with_text":
				html += iconWithTextToHTML(c);
				break;
			case "image_with_text":
				html += imageWithTextToHTML(c);
				break;
			case "image_with_text_2":
				html += imageWithText2ToHTML(c);
				break;
			case "image_with_text_3":
				html += imageWithText3ToHTML(c);
				break;
			case "video":
				html += videoToHTML(c);
				break;
			case "button":
				html += buttonToHTML(c);
				break;
			case "table":
				html += tableToHTML(c);
				break;
		}
	}

	return html;
}

// converts the article sources to html

export function sourcesToHTML(sources: { text: string, link: string }[]) {
	let html = "";

	for (let source of sources) {
		html += `<li><a href="${source.link}">${source.text}</a></li>`;
	}

	if (html === "") {
		return '';
	}

	return `<p style="margin: 0 150px;" class="bl-font magazin-size">Quellen:</p>
	<ul class="article-source-list">${html}</ul>`;
}
